import {
  useQuery,
  type UseQueryResult,
} from '@tanstack/react-query'
import { pickupRecordsApi } from '@/lib/api'
import type { PickupRecord } from '@/types'

export const pickupRecordKeys = {
  all: ['pickup-records'] as const,
  lists: () => [...pickupRecordKeys.all, 'list'] as const,
  list: (pickupId?: number) => [...pickupRecordKeys.lists(), pickupId] as const,
  detail: (id: number) => [...pickupRecordKeys.all, 'detail', id] as const,
}

export function usePickupRecords(pickupId?: number): UseQueryResult<PickupRecord[]> {
  return useQuery({
    queryKey: pickupRecordKeys.list(pickupId),
    queryFn: async () => {
      const res = await pickupRecordsApi.list(pickupId)
      return res.data
    },
    enabled: Boolean(pickupId),
  })
}

export function usePickupRecord(id: number): UseQueryResult<PickupRecord> {
  return useQuery({
    queryKey: pickupRecordKeys.detail(id),
    queryFn: async () => {
      const res = await pickupRecordsApi.get(id)
      return res.data
    },
    enabled: Boolean(id),
  })
}
